import {combine} from 'effector';

import {fetchParentCodesGrid} from 'api/documents/aggregation';
import {createGridTableModel} from 'core/hooks/grid2.0';
import {rootDomain} from 'core/rootDomain';
import {AggregationParentCode} from 'types';

const domain = rootDomain.createDomain('DocumentsParentCodesGridTableDomain');

export const fetchDataFx = domain.createEffect({
    name: 'fetchDataFx',
    handler: fetchParentCodesGrid,
});

export const {
    filters$,
    filtersChanged,
    filtersReset,
    defaultFilters,
    pageNumber$,
    pageNumberChanged,
    pageSize$,
    pageSizeChanged,
    Gate,
    tableStateChanged,
    tableStateCacheChanged,
    stateReset,
} = createGridTableModel({
    domain,
});

export const data$ = domain.createStore<{
    nextPageRef: string;
    data: AggregationParentCode[];
} | null>(null);

export const searchChanged = domain.createEvent<string>();
export const search$ = domain.createStore<string | null>(null);

export const gridCacheReset = domain.createEvent();
export const gridTokensCache$ = domain.createStore<Record<number, string | null>>({0: null});

export const tableState$ = combine({
    data: data$,
    pageNumber: pageNumber$,
    pageSize: pageSize$,
    filters: filters$,
    gridTokensCache: gridTokensCache$,
    isLoading: fetchDataFx.pending,
});
